/**
 * Заменяет все вхождения точки на запятую в заданной строке.
 *
 * @param {string} str - Строка.
 * @return {string} Измененная строка с заменой точек на запятые.
 */
export default function replaceDotToComma(str) {
    return str.toString().replace('.', ',')
}

